import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { AccountNameAndEmailSettings } from "components/settings/account-name-and-email-settings";
import { saveAccountSettingsAction } from "actions/account-settings-actions";
import { Loading } from "components/common/loading";

const AccountNameAndEmailPage = (props) => {
  if (props.isLoading) {
    return <Loading />;
  }
  return <AccountNameAndEmailSettings { ...props } />;
};

AccountNameAndEmailPage.propTypes = {
  isLoading: PropTypes.bool.isRequired
};

const mapStateToProps = (state) => ({
  accountId: state.app.selectedAccount.id,
  emailPin: state.accountSettings.emailPin,
  isLoading: state.accountSettings.isLoading,
  label: state.accountSettings.label,
  slug: state.accountSettings.slug
});

const mapDispatchToProps = (dispatch) => ({
  onSaveNameAndEmail: () => dispatch(saveAccountSettingsAction())
});

export const AccountNameAndEmailContainer = connect(mapStateToProps, mapDispatchToProps)(AccountNameAndEmailPage);



// WEBPACK FOOTER //
// ./src/js/containers/settings/account-name-and-email-container.jsx